<template>
  <div>
    <a-row :gutter="[24, 24]">
      <a-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
        :lg="{ span: 20, offset: 2 }"
        style="margin-top: 10px"
      >
        <div class="card-container">
          <a-tabs type="card" defaultActiveKey="1" @change="callback">
            <a-tab-pane key="1" tab="Cancers">
              <div
                :span="24"
                style="
                  font-size: 20px;
                  font-weight: bolder;
                  color: black;
                  margin-top: 5px;
                "
              >
                <a-icon type="forward" /> Select a cancer type
              </div>
              <div
                style="text-align: left; margin-top: 10px; margin-bottom: 10px"
              >
                <a-select
                  style="width: 100%"
                  defaultValue="BRCA"
                  size="large"
                  @change="handleChange"
                >
                  <a-select-option key="1" value="BLCA"
                    >Bladder Urothelial Carcinoma (TCGA-BLCA)</a-select-option
                  >
                  <a-select-option key="2" value="BRCA"
                    >Breast invasive carcinoma (TCGA-BRCA)</a-select-option
                  >
                  <a-select-option key="3" value="CESC"
                    >Cervical squamous cell carcinoma and endocervical
                    adenocarcinoma (TCGA-CESC)</a-select-option
                  >
                  <a-select-option key="4" value="CHOL"
                    >Cholangio carcinoma (TCGA-CHOL)</a-select-option
                  >
                  <a-select-option key="5" value="COAD"
                    >Colon adenocarcinoma (TCGA-COAD)</a-select-option
                  >
                  <a-select-option key="6" value="ESCA"
                    >Esophageal carcinoma (TCGA-ESCA)</a-select-option
                  >
                  <a-select-option key="7" value="GBM"
                    >Glioblastoma multiforme (TCGA-GBM)</a-select-option
                  >
                  <a-select-option key="8" value="HNSC"
                    >Head and Neck squamous cell carcinoma
                    (TCGA-HNSC)</a-select-option
                  >
                  <a-select-option key="9" value="KICH"
                    >Kidney Chromophobe (TCGA-KICH)</a-select-option
                  >
                  <a-select-option key="10" value="KIRC"
                    >Kidney renal clear cell carcinoma
                    (TCGA-KIRC)</a-select-option
                  >
                  <a-select-option key="11" value="KIRP"
                    >Kidney renal papillary cell carcinoma
                    (TCGA-KIRP)</a-select-option
                  >
                  <a-select-option key="12" value="LIHC"
                    >Liver hepatocellular carcinoma (TCGA-LIHC)</a-select-option
                  >
                  <a-select-option key="13" value="LUAD"
                    >Lung adenocarcinoma (TCGA-LUAD)</a-select-option
                  >
                  <a-select-option key="14" value="LUSC"
                    >Lung squamous cell carcinoma (TCGA-LUSC)</a-select-option
                  >
                  <a-select-option key="15" value="PCPG"
                    >Pheochromocytoma and Paraganglioma
                    (TCGA-PCPG)</a-select-option
                  >
                  <a-select-option key="16" value="PRAD"
                    >Prostate adenocarcinoma (TCGA-PRAD)</a-select-option
                  >
                  <a-select-option key="17" value="READ"
                    >Rectum adenocarcinoma (TCGA-READ)</a-select-option
                  >
                  <a-select-option key="18" value="SARC"
                    >Sarcoma (TCGA-SARC)</a-select-option
                  >
                  <a-select-option key="19" value="STAD"
                    >Stomach adenocarcinoma (TCGA-STAD)</a-select-option
                  >
                  <a-select-option key="20" value="THCA"
                    >Thyroid carcinoma (TCGA-THCA)</a-select-option
                  >
                  <a-select-option key="21" value="THYM"
                    >Thymoma (TCGA-THYM)</a-select-option
                  >
                  <a-select-option key="22" value="UCEC"
                    >Uterine Corpus Endometrial Carcinoma
                    (TCGA-UCEC)</a-select-option
                  >
                </a-select>
              </div>
              <a-row>
                <a-col :span="24">
                  <geneTable v-model="value" />
                </a-col>
              </a-row>
            </a-tab-pane>
          </a-tabs>
        </div>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import geneTable from "./gene_table.vue";

export default {
  components: { geneTable },
  methods: {
    handleChange(value) {
      this.value = value;
    },
  },
  data() {
    return {
      value: "BRCA",
      formLayout: "horizontal",
      customStyle:
        "background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden;font-size:25px;line-height:25px",
    };
  },
};
</script>
<style scpoed>
.h1 {
  font-size: 40px;
  font-weight: bolder;
}
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
.downloadbutton {
  background-color: aqua;
  border-color: black;
  padding: 3px 3px;
}
.card-container {
  background: #f5f5f5;
  overflow: hidden;
  padding: 4px;
}
</style>
